import { bool, oneOf, shape } from 'prop-types';

export const backgroundVariantOptions = oneOf([
    '#FFFFFF',
    '#003057',
    '#F5FBFF',
    '#F1F6FA',
    'none'
]);
const cardBackgroundColorOptions = oneOf([
    'white',
    'grey',
    'everyday_gradient',
    'smart_gradient',
    'smart_plus_gradient'
]);

const hideByDeviceSize = {
    hideOnDesktop: bool,
    hideOnMobile: bool
};

const commonOptionsPropType = {
    commonOptions: shape({
        backgroundVariant: backgroundVariantOptions,
        cardBackground: cardBackgroundColorOptions,
        ...hideByDeviceSize
    })
};

export default commonOptionsPropType;
